import http from '../services/http';
import { typeAs } from '../services/utils';

export default {
  namespaced: true,

  state: {
    ir: null,
    governance: null,
  },

  mutations: {
    INIT_IR(state) {
      state.ir = {};
    },
    CLEAR_IR(state) {
      state.ir = null;
      state.governance = null;
    },
    SET_IR(state, data) {
      state.ir = data;
    },
    SET_GOVERNANCE(state, data) {
      state.governance = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_IR');
    },

    find({ commit }) {
      return http('/ir')
        .then((response) => response.body)
        .then(typeAs('IR'))
        .then((response) => {
          commit('SET_IR', response);
          return response;
        });
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http('/ir', { method: 'PUT', data })
        : http('/ir', { method: 'POST', data });

      return request.then((response) => response.body.item);
    },

    findGovernance({ commit }, type) {
      return http(`/ir/governance/${type}`)
        .then((response) => response.body)
        .then(typeAs('IR'))
        .then((response) => {
          commit('SET_GOVERNANCE', response);
          return response;
        });
    },

    saveGovernance(_, {
      type, ...data
    }) {
      const request = http(`/ir/governance/${type}`, { method: 'POST', data });

      return request.then((response) => response.body.item);
    },
  },
};
